import { useState } from "react";
import { Link } from "react-router-dom";

export default function Header({ scrollToSection }) {
  const [menuOpen, setMenuOpen] = useState(false);

  const go = (id) => {
    setMenuOpen(false);
    scrollToSection(id);
  };

  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          <Link
            to="/"
            className="logo"
            onClick={(e) => {
              setMenuOpen(false);
              if (window.location.pathname === "/") {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: "smooth" });
              }
            }}
          >
            <img
              src="/logo-white.png"
              alt="PayraBook"
              className="header-logo-img"
            />
          </Link>

          <div className={`nav-links${menuOpen ? " open" : ""}`}>
            <button onClick={() => go("about-erp")}>
              About ERP
            </button>

            <button onClick={() => go("our-products")}>
              Our Products
            </button>

            <button onClick={() => go("pricing")}>
              Pricing
            </button>

            <button onClick={() => go("reviews")}>
              Reviews
            </button>

          </div>

          <div className="nav-cta">
            <button
              onClick={() => scrollToSection("contact")}
              className="btn btn-primary"
            >
              Request Callback
            </button>
          </div>

          <button
            type="button"
            className="menu-toggle"
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
          >
            {menuOpen ? "✕" : "☰"}
          </button>
        </nav>
      </div>
    </header>
  );
}